import { useState } from "react"
import { useLocation } from "react-router-dom"
import { buildSigmaLinkParams } from "../helpers/build-sigma-link-params"

interface CapturedLink {
  solutionId: string
  params: string
}

export function useSigmaLinkParams(solutionId: string) {
  const { search } = useLocation()
  const [captured, setCaptured] = useState<CapturedLink>(() => ({ solutionId, params: buildSigmaLinkParams(search) }))

  if (captured.solutionId === solutionId) {
    return captured.params
  }

  const recaptured = { solutionId, params: buildSigmaLinkParams(search) }
  setCaptured(recaptured)
  return recaptured.params
}
